import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTriggerOnScroll } from '@client/hooks/useTriggerOnScroll'
import { getBanners } from '@client/selectors/appSelectors'
import { Lang } from '@client/types'
import { getBannersByPlatform } from '@client/utils/getBannersByPlatform'

import { usePopoverBannerStorage } from './helpers'
import { PopupBanner } from './PopupBanner'

export const PopupBannerContainer = ({
  parentRef,
  lang
}: {
  parentRef: React.RefObject<HTMLDivElement>
  lang: Lang
}) => {
  const [shouldRender, setShouldRender] = useState(false)
  const { storage, isDismissed } = usePopoverBannerStorage(lang)

  const popupsData = useSelector(getBanners)

  const isVisible = useTriggerOnScroll(parentRef, 30)

  const popups = getBannersByPlatform(popupsData?.popup)
  const popup = popups?.[0]

  useEffect(() => {
    if (!storage || isDismissed) {
      return
    }

    setShouldRender(!isDismissed)
  }, [storage, isDismissed])

  if (!popup || !shouldRender) {
    return null
  }

  return (
    <PopupBanner
      content={popup}
      shouldRender={shouldRender}
      setShouldRender={setShouldRender}
      isVisible={isVisible}
      layout="simple"
      lang={lang}
    />
  )
}
